/* eslint-disable*/
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect, useRef } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { Formik } from 'formik';
import { CSVLink } from 'react-csv';
import TableContainer from '@material-ui/core/TableContainer';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import { Bar, Line } from 'react-chartjs-2';
import MaterialTable from 'material-table';
import CustomDropdown from '../../../../components/CustomDropdown';
import { ReactComponent as Sheets } from '../../../../assets/images/Sheets.svg';

import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Slide,
  Checkbox,
  ClickAwayListener,
  TableCell,
  TableHead,
  TableRow,
  Popover,
  Snackbar,
  FormControl,
  Select,
} from '@material-ui/core';

import useForms from '../../../../hooks/useForms';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import useDashboard from '../../../../hooks/useDashboard';
import usePractice from '../../../../hooks/usePractice';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
/* CSS */
import useStyles from '../../Main.style';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OAuthClient from 'intuit-oauth';
import FinancialProgression from '../FinancialProgression/FinancialProgression';
import ProfitQb from '../ProfitQb/ProfitQb';
import RevenueQb from '../RevenueQb/RevenueQb';
import RevenueTotal from '../RevenueTotal/RevenueTotal';
import SummaryInvoiceByCell from '../SummaryInvoiceByCell/SummaryInvoiceByCell';

/* New */

export const optionsForTotalActivities = {
  indexAxis: 'y', // as const,
  elements: {
    bar: {
      borderWidth: 1,
      barThickness: 60, // Adjust this value to increase the width of the bar
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: false, // as const,
    },
    title: {
      display: true,
      text: 'Sum of Complexity',
      position: 'bottom',
    },
  },
};
/* New */

const CellWorkLoad = ({
  myCellWorkLoadListFromMyCell,
  clientComplexityScoreFromMyCell,
  myCellWorkLoadNumbersFromMyCell,
  countryList,
  cellListForFilterFromMyCell,
  managementMyCellListFromMyCell,
}) =>
  // React.memo(function MyPerformanceSalesUser(
  //   myCellWorkLoadListFromMyCell,
  //   clientComplexityScoreFromMyCell,
  //   myCellWorkLoadNumbersFromMyCell,
  //   countryList,
  //   cellListForFilterFromMyCell,
  //   managementMyCellListFromMyCell,
  // )
  {
    console.log(cellListForFilterFromMyCell, 4240.5);
    //const CellWorkLoad = () => {
    const classes = useStyles();
    const key = 'iFrasCwdJh';
    const userCookie = Cookies.get('user');
    const csvLinkEl = useRef();
    let bytes = CryptoJS.AES.decrypt(userCookie, key);
    const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    const [cellWorkLoadNunbers, setCellWorkLoadNunbers] = useState([]);
    const [clientComplexityScore, setClientComplexityScore] = useState([]);
    const [filteredSelectedCountryData, setFilteredSelectedCountryData] = useState([]);
    const [basicDetailsData, setBasicDetailsData] = useState([]);
    const [cellList, setCellList] = useState([]);
    const [clientsHandledByCell, setClientsHandledByCell] = useState([]);
    const [
      averageClientsHandledPerOpsAssociate,
      setAverageClientsHandledPerOpsAssociate,
    ] = useState([]);
    const [isApplyClicked, setIsApplyClicked] = useState(false);
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const SelectAllCells = { cellTitle: 'Select All' };
    const [selectedCellOption, setSelectedCellOption] = useState([]);
    const [totalFileCellListData, setTotalFileCellListData] = useState([]);
    const [totalFileCellListValueData, setTotalFileCellListValueData] = useState([]);
    const [cellListForFilter, setCellListForFilter] = useState([]);
    // const [countryList, setCountryList] = useState([]);
    const [country, setCountry] = useState(loggedInUserData?.country?.countryTitle);
    const [countryShortName, setCountryShortName] = useState(loggedInUserData?.country?.shortName);
    const [copyCellListForFilter, setCopyCellListForFilter] = useState([]);
    const [selectedCellValue, setSelectedCellValue] = useState(loggedInUserData?.cell?.cellValue);
    const [selectedCell, setSelectedCell] = useState(loggedInUserData?.cell?.cellTitle);
    const [selectedCountryValue, setSelectedCountryValue] = useState(
      loggedInUserData?.country?.countryValue,
    );
    const [isLoadedFirstTime, setIsLoadedFirstTime] = useState(true);
    const theme = useTheme();

    const {
      getCellWorkLoadNunbers,
      getCellWorkLoadList,
      getClientComplexityScoreTable,
      getFileManagementMyCellTable,
    } = useDashboard();
    const { fetchAllCellList, getCountry } = usePractice();
    const loadCellWorkLoadNunbers = async () => {
      const myCellWorkLoadNunbers = isLoadedFirstTime
        ? myCellWorkLoadNumbersFromMyCell
        : await getCellWorkLoadNunbers({
            cellValue: selectedCellValue,
            countryTitle: selectedCountryValue,
          });

      setCellWorkLoadNunbers(myCellWorkLoadNunbers?.initialValues);
      setBasicDetailsData(myCellWorkLoadNunbers?.basicDetailsUrlData?.[0]);
    };

    const csvHeaders = [
      { key: 'cell', label: 'Cell' },
      { key: 'client', label: 'Client' },
      { key: 'complexity', label: 'Complexity Score', default: 100 },
      { key: 'files', label: 'Active Files', default: 10 },
      { key: 'averageProfitPerClient', label: 'Average Gross Profit Per Client' },
    ];

    const handleLinkCLick = async () => {
      csvLinkEl.current.link.click();
    };

    const loadClientComplexityScoreTable = async () => {
      const clientComplexityScoreTableData = clientComplexityScoreFromMyCell;
      setClientComplexityScore(clientComplexityScoreTableData?.clientData);
    };
    const loadCellWorkLoadList = async () => {
      const myCellWorkLoadList = isLoadedFirstTime
        ? myCellWorkLoadListFromMyCell
        : await getCellWorkLoadList({
            cellValue: selectedCellValue,
            countryTitle: selectedCountryValue,
          });

      setFilteredSelectedCountryData(myCellWorkLoadList?.filteredSelectedCountryData);

      setClientsHandledByCell(
        myCellWorkLoadList?.avgRankingDetailsUrlData?.sort(
          (a, b) => b?.totalActiveClients - a?.totalActiveClients,
        ),
      );
      setAverageClientsHandledPerOpsAssociate(
        myCellWorkLoadList?.avgRankingDetailsUrlData?.sort(
          (a, b) => b?.totalActiveClientsPerOpsAssociate - a?.totalActiveClientsPerOpsAssociate,
        ),
      );
    };

    const showReports = async (cellValue, countryTitle) => {
      const myCellWorkLoadNunbers = await getCellWorkLoadNunbers({
        cellValue: cellValue,
        countryTitle: countryTitle,
      });

      setCellWorkLoadNunbers(myCellWorkLoadNunbers?.initialValues);
      setBasicDetailsData(myCellWorkLoadNunbers?.basicDetailsUrlData[0]);
    };

    const loadManagementMyCellList = async (cellValue, countryTitle) => {
      //const loadManagementMyCellList = async () => {
      const managementMyCellList = !isLoadedFirstTime
        ? await getFileManagementMyCellTable({
            cellValue: cellValue, //loggedInUserData?.cell?.cellValue,
            countryTitle: countryTitle, //loggedInUserData?.country?.shortName,
          })
        : managementMyCellListFromMyCell;
      setTotalFileCellListData(managementMyCellList?.totalFileCellList);
      setTotalFileCellListValueData(managementMyCellList?.totalFileCellListValue);
    };

    const loadCountries = async () => {
      // const countryLists = await getCountry();
      //setCountryList(countryList.usersResult || []);
    };

    const showListReports = async (cellLists, cellValue, countryTitle) => {
      const myCellWorkLoadList = await getCellWorkLoadList({
        cellValue: cellValue,
        countryTitle: countryTitle,
        cellLists: cellLists,
      });

      setFilteredSelectedCountryData(myCellWorkLoadList?.filteredSelectedCountryData);

      setClientsHandledByCell(
        myCellWorkLoadList?.avgRankingDetailsUrlData?.sort(
          (a, b) => b?.totalActiveClients - a?.totalActiveClients,
        ),
      );
      setAverageClientsHandledPerOpsAssociate(
        myCellWorkLoadList?.avgRankingDetailsUrlData?.sort(
          (a, b) => b?.totalActiveClientsPerOpsAssociate - a?.totalActiveClientsPerOpsAssociate,
        ),
      );
    };

    const loadCells = async () => {
      const fetchedCellList = cellListForFilterFromMyCell;
      console.log(cellListForFilterFromMyCell, 4241);
      setCellList(fetchedCellList);
      setCopyCellListForFilter(fetchedCellList);
      setCellListForFilter(fetchedCellList);
    };

    useEffect(() => {
      // loadCountries();
      loadCells();
      loadManagementMyCellList(
        loggedInUserData?.cell?.cellValue,
        loggedInUserData?.country?.shortName,
      );
    }, []);

    useEffect(() => {
      loadCellWorkLoadNunbers();
    }, []);

    useEffect(() => {
      loadCellWorkLoadList();
    }, []);

    useEffect(() => {
      loadClientComplexityScoreTable();
    }, []);

    /* New */
    const [totalOperations, setTotalOperations] = useState([]);

    const dataForTotalActivities = {
      labels: totalFileCellListData,
      datasets: [
        {
          data: totalFileCellListValueData,
          backgroundColor: totalFileCellListData?.map((label) =>
            label === loggedInUserData?.cell?.cellValue ? '#003C6F' : '#0F6E8C',
          ),
        },
      ],
    };

    const [dropdownValue, setDropdownValue] = useState('');

    const handleDropdownChange = (event) => {
      setDropdownValue(event.target.value);
    };

    const [personName, setPersonName] = React.useState([]);

    const handleChange = (event) => {
      const {
        target: { value },
      } = event;
      setPersonName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
      getContentAnchorEl: null,
    };

    const names = [
      'Oliver Hansen',
      'Van Henry',
      'April Tucker',
      'Ralph Hubbard',
      'Omar Alexander',
      'Carlos Abbott',
      'Miriam Wagner',
      'Bradley Wilkerson',
      'Virginia Andrews',
      'Kelly Snyder',
    ];
    /* New */

    return (
      <Grid container spacing={4}>
        <Grid item xs={12}></Grid>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="h5">Cell Workload</Typography>
                    <Box display="flex" justifyContent="flex-end">
                      <Box width={200} mr={2}>
                        <Autocomplete
                          options={countryList}
                          getOptionLabel={(option) => option?.countryTitle}
                          getOptionSelected={(option, value) =>
                            option?.countryTitle === value?.countryTitle || country
                          }
                          value={
                            country ? countryList?.find((d) => d?.countryTitle === country) : null
                          }
                          onChange={async (event, newValue) => {
                            const filteredCellList = cellList?.filter(
                              (cell) => cell?.countryDetails?.shortName === newValue?.shortName,
                            );
                            setIsLoadedFirstTime(false);
                            setSelectedCellValue(filteredCellList[0]?.cellValue);
                            setSelectedCountryValue(newValue?.countryValue);
                            setSelectedCell(filteredCellList[0]?.cellTitle || null);
                            setCountry(newValue?.countryTitle);
                            setCountryShortName(newValue?.shortName);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="Country"
                              variant="outlined"
                              label={
                                country
                                  ? countryList?.find((d) => d?.countryTitle === country)
                                      ?.countryTitle
                                  : null
                              }
                            />
                          )}
                          popupIcon={<ExpandMoreIcon />}
                        />
                      </Box>
                      <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        autoFocus
                        onClick={() => {
                          loadManagementMyCellList(
                            loggedInUserData?.cell?.cellValue,
                            countryShortName,
                          );
                          showReports(selectedCellValue, selectedCountryValue);
                        }}
                      >
                        Apply
                      </Button>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} style={{ height: '100%' }}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        CURRENT WORKLOAD
                      </Typography>
                    </Box>
                    <Box mt={1}>
                      <Bar
                        options={optionsForTotalActivities || []}
                        data={dataForTotalActivities || []}
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.WorkLoadDropdownOutline}>
                      <Autocomplete
                        options={cellList}
                        getOptionLabel={(option) => option?.cellTitle}
                        value={cellList?.find((d) => d?.cellTitle === selectedCell)?.cellTitle}
                        getOptionSelected={(option, value) => {
                          return option?.cellTitle === selectedCell;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="Cell"
                            variant="outlined"
                            label={
                              selectedCell
                                ? cellList?.find((d) => d?.cellTitle === selectedCell)?.cellTitle
                                : selectedCell
                            }
                          />
                        )}
                        popupIcon={<ExpandMoreIcon />}
                        onChange={async (event, newValue) => {
                          setIsLoadedFirstTime(false);
                          if (newValue == null) {
                            showReports(
                              loggedInUserData?.cell?.cellValue,
                              loggedInUserData?.country?.countryValue,
                            );
                          } else {
                            showReports(
                              newValue?.cellValue,
                              newValue?.countryDetails?.countryValue,
                            );
                          }

                          setSelectedCellValue(newValue?.cellValue);
                          setSelectedCountryValue(newValue?.countryDetails?.countryValue);
                          setSelectedCell(newValue?.cellTitle);
                        }}
                      />
                      {/* <Autocomplete
                      popupIcon={<KeyboardArrowDownIcon />}
                      classes={{
                        popupIndicator: classes.popupIndicator,
                      }}
                      options={cellList}
                      disableCloseOnSelect={true}
                      getOptionLabel={(item) => item?.cellTitle}
                      fullWidth
                      //multiple
                      //size="small"
                      //limitTags={6}
                      //onChange={(e, value) => setFieldValue('studios', value)}
                      getOptionSelected={(option, value) => {
                        return option?.cellTitle === selectedCell;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="Cell"
                          variant="outlined"
                          label={
                            selectedCell
                              ? cellList?.find((d) => d?.cellTitle === selectedCell)?.cellTitle
                              : null
                          }
                        />
                      )}
                      groupBy={(item) => item?.countryDetails?.shortName}
                      renderGroup={({ children, group, item }) => {
                        return [
                          <Box p={0.5} pl={1}>
                            <ReactCountryFlag
                              countryCode={group}
                              svg
                              style={{
                                width: '2em',
                                height: '2em',
                                marginRight: '8px',
                              }}
                              title={group}
                            />

                            {
                              countryList.find((country) => country?.shortName === group)
                                .countryTitle
                            }
                          </Box>,
                          children,
                        ];
                      }}
                      renderOption={(option, data) => (
                        <Box p={0.5}>
                          <div>
                            <span className={classes.fontGrey}>{option?.cellTitle}</span>
                          </div>
                        </Box>
                      )}
                    /> */}
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                      <Box className={classes.innercontentWhite} height="100%">
                        <Box display="flex" flexDirection="column">
                          <Box display="flex">
                            <Typography variant="h2" noWrap>
                              {basicDetailsData?.totalActiveClients
                                ? basicDetailsData?.totalActiveClients
                                : 'NA'}
                            </Typography>
                          </Box>
                          <Box display="flex" mt={1}>
                            <Typography variant="body2" noWrap>
                              Total Active Clients
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                      <Box className={classes.innercontentWhite} height="100%">
                        <Box display="flex" flexDirection="column">
                          <Box display="flex">
                            <Typography variant="h2" noWrap>
                              {basicDetailsData?.averageClientComplexity
                                ? basicDetailsData?.averageClientComplexity
                                : 'NA'}
                            </Typography>
                          </Box>
                          <Box display="flex" mt={1}>
                            <Typography variant="body2" noWrap>
                              Average Client Complexity
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                      <Box className={classes.innercontentWhite} height="100%">
                        <Box display="flex" flexDirection="column">
                          <Box display="flex">
                            <Typography variant="h2" noWrap>
                              {basicDetailsData?.totalActiveFiles
                                ? basicDetailsData?.totalActiveFiles
                                : 'NA'}
                            </Typography>
                          </Box>
                          <Box display="flex" mt={1}>
                            <Typography variant="body2" noWrap>
                              Total Active Files
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                  <Box className={classes.innercontentWhite} mt={2}>
                    <Box display="flex" justifyContent="space-between" mb={2}>
                      <Typography variant="h5" noWrap>
                        CLIENT COMPLEXITY SCORE
                      </Typography>
                      <>
                        <a onClick={(event) => handleLinkCLick()}>
                          <Box className={classes.TableIconText} display="flex" alignItems="center">
                            <Box mr={0.5} display="flex">
                              <Sheets />
                            </Box>
                            <Box>
                              <Typography variant="body1">Complexity Scores</Typography>
                            </Box>
                          </Box>
                        </a>
                        <CSVLink
                          data={clientComplexityScore || []} // the CSV data
                          headers={csvHeaders || []}
                          filename={'Client_Complexity_Score.csv'}
                          ref={csvLinkEl} // attach the ref
                          style={{ display: 'none' }} // hide this element
                        />
                      </>
                    </Box>
                    <Box>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        className={classes.materialDT}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="CLIENT COMPLEXITY SCORE"
                        columns={[
                          {
                            title: selectedCellValue,
                            field: 'cell',
                            render: (data) => data?.client,
                          },
                          {
                            title: 'Complexity Score',
                            field: 'score',
                            render: (data) => data?.complexity || 100,
                          },
                          {
                            title: 'Active Files',
                            field: 'files',
                            render: (data) => data?.myrank || 10,
                          },
                          {
                            title: 'Average Gross Profit Per Client',
                            field: 'averageProfitPerClient',
                            render: (data) => data?.averageProfitPerClient,
                          },
                        ]}
                        data={clientComplexityScore?.slice(0, 5) || []}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5">Operational Metrics</Typography>
                    <Box className={classes.WorkLoadDropdownOutline}>
                      <Formik
                        enableReinitialize={false}
                        initialValues={{
                          cellid: [],
                        }}
                        onSubmit={async (values, { resetForm }) => {
                          setIsLoadedFirstTime(false);
                          values.cellValue = loggedInUserData?.cell?.cellValue;
                          values.countryTitle = loggedInUserData?.country?.countryValue;
                          showListReports(values);
                          resetForm();
                        }}
                      >
                        {({ submitForm, setFieldValue }) => {
                          return (
                            <Box display="flex" justifyContent="flex-end">
                              {console.log(cellListForFilter, 4242)}
                              <Box width={200} mr={2}>
                                <Autocomplete
                                  fullWidth
                                  multiple
                                  id="cells"
                                  disableCloseOnSelect
                                  options={
                                    cellListForFilter?.length > 0
                                      ? [SelectAllCells, ...cellListForFilter]
                                      : [SelectAllCells, []]
                                  }
                                  getOptionLabel={(option) => {
                                    return option?.cellTitle;
                                  }}
                                  onChange={(event, newValue) => {
                                    newValue.length === 0 && setSelectedCellOption(newValue);
                                  }}
                                  renderTags={() => {}}
                                  renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                      {option === SelectAllCells ? (
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={
                                                selectedCellOption.length ===
                                                cellListForFilter.length
                                              }
                                            />
                                          }
                                          label={option?.cellTitle}
                                          onChange={(event) => {
                                            if (event.target.checked) {
                                              setSelectedCellOption(cellListForFilter);
                                              setFieldValue('cellid', cellListForFilter || []);
                                            } else {
                                              setFieldValue('cellid', []);
                                              setSelectedCellOption([]);
                                            }
                                          }}
                                        />
                                      ) : (
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selectedCellOption.some(
                                                (selectedOption) =>
                                                  selectedOption.cellTitle === option.cellTitle,
                                              )}
                                              onChange={() => {
                                                setIsApplyClicked(false);
                                                const isSelected = selectedCellOption.some(
                                                  (selectedOption) =>
                                                    selectedOption.cellTitle === option.cellTitle,
                                                );

                                                let newSelectedOptions = [];

                                                if (isSelected) {
                                                  newSelectedOptions = selectedCellOption.filter(
                                                    (selectedOption) =>
                                                      selectedOption.cellTitle !== option.cellTitle,
                                                  );
                                                } else {
                                                  newSelectedOptions = [
                                                    ...selectedCellOption,
                                                    option,
                                                  ];
                                                }

                                                setSelectedCellOption(newSelectedOptions);
                                                setFieldValue('cellid', newSelectedOptions || []);
                                              }}
                                            />
                                          }
                                          label={option?.cellTitle}
                                        />
                                      )}
                                    </React.Fragment>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      name="cellid"
                                      variant="outlined"
                                      label={
                                        selectedCellOption.length > 1 &&
                                        selectedCellOption.length <= cellListForFilter.length
                                          ? 'Multiple Cells'
                                          : selectedCellOption.length == 1
                                          ? selectedCellOption[0].cellTitle
                                          : 'Select Cell'
                                      }
                                    />
                                  )}
                                  popupIcon={<ExpandMoreIcon />}
                                />
                              </Box>
                              <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                autoFocus
                                onClick={() => {
                                  submitForm();
                                }}
                              >
                                Apply
                              </Button>
                            </Box>
                          );
                        }}
                      </Formik>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.innercontentWhite}>
                    <Box mb={2}>
                      <Typography variant="h5" noWrap>
                        TOTAL OPERATIONS FTES
                      </Typography>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor1} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    Vector Average
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {cellWorkLoadNunbers?.avgTotalOperations}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Employees
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor1} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    Vector Top Cell
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {cellWorkLoadNunbers?.maxOperationTopCell?.totalActiveUsers}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Employees
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor2} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    {selectedCellValue}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {basicDetailsData?.totalActiveUsers}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Employees
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={7}>
                        <Grid container spacing={2} className={classes.CellScrollBox}>
                          {filteredSelectedCountryData?.map((data, index) => (
                            <>
                              <Grid item xs={4}>
                                <Box className={classes.innercontentDefaultcolor} height="100%">
                                  <Box display="flex" flexDirection="column">
                                    <Box display="flex">
                                      <Typography variant="h5" noWrap>
                                        {data?.cell}
                                      </Typography>
                                    </Box>
                                    <Box display="flex">
                                      <Typography variant="h6" noWrap>
                                        {data?.country}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={3}>
                                      <Typography variant="h2" noWrap>
                                        {data?.totalActiveUsers}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={1}>
                                      <Typography variant="body2" noWrap>
                                        Employees
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                            </>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.innercontentWhite}>
                    <Box mb={2}>
                      <Typography variant="h5" noWrap>
                        AVERAGE CLIENTS HANDLED PER OPS ASSOCIATE
                      </Typography>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor1} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    Vector Average
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography
                                    variant="h2"
                                    noWrap
                                    className={classes.CellWorkRankingNA}
                                  >
                                    N/A
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Ranking
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {cellWorkLoadNunbers?.averageClientHandledPerAssociate}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Clients
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor1} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    Vector Top Cell
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography
                                    variant="h2"
                                    noWrap
                                    className={classes.CellWorkRankingGreen}
                                  >
                                    1
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Ranking
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {
                                      cellWorkLoadNunbers?.maxClientHandeledPerOps
                                        ?.totalActiveClientsPerOpsAssociate
                                    }
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Clients
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor2} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    {selectedCellValue}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography
                                    variant="h2"
                                    noWrap
                                    className={classes.CellWorkRankingBlue}
                                  >
                                    {averageClientsHandledPerOpsAssociate?.findIndex(
                                      (item) =>
                                        item?.country === selectedCountryValue &&
                                        item?.cell === selectedCellValue,
                                    ) + 1}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Ranking
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {basicDetailsData?.totalActiveClientsPerOpsAssociate}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Clients
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={7}>
                        <Grid container spacing={2} className={classes.CellScrollBox}>
                          {filteredSelectedCountryData?.map((data, index) => (
                            <>
                              <Grid item xs={4}>
                                <Box className={classes.innercontentDefaultcolor} height="100%">
                                  <Box display="flex" flexDirection="column">
                                    <Box display="flex">
                                      <Typography variant="h5" noWrap>
                                        {data?.cell}
                                      </Typography>
                                    </Box>
                                    <Box display="flex">
                                      <Typography variant="h6" noWrap>
                                        {data?.country}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={3}>
                                      <Typography
                                        variant="h2"
                                        noWrap
                                        className={classes.CellWorkRankingBlue}
                                      >
                                        {averageClientsHandledPerOpsAssociate?.findIndex(
                                          (item) =>
                                            item?.country === data?.country &&
                                            item?.cell === data?.cell,
                                        ) + 1}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={1}>
                                      <Typography variant="body2" noWrap>
                                        Ranking
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={3}>
                                      <Typography variant="h2" noWrap>
                                        {data?.totalActiveClientsPerOpsAssociate}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={1}>
                                      <Typography variant="body2" noWrap>
                                        Clients
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                            </>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.innercontentWhite}>
                    <Box mb={2}>
                      <Typography variant="h5" noWrap>
                        CLIENTS HANDLED BY CELL
                      </Typography>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor1} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    Vector Average
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography
                                    variant="h2"
                                    noWrap
                                    className={classes.CellWorkRankingNA}
                                  >
                                    N/A
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Ranking
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {cellWorkLoadNunbers?.averageClientHandledByCell}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Clients
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor1} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    Vector Top Cell
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography
                                    variant="h2"
                                    noWrap
                                    className={classes.CellWorkRankingGreen}
                                  >
                                    1
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Ranking
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {
                                      cellWorkLoadNunbers?.maxClientHandeledPerCell
                                        ?.totalActiveClients
                                    }
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Clients
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box className={classes.innercontentcolor2} height="100%">
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Typography variant="h5" noWrap>
                                    {selectedCellValue}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography
                                    variant="h2"
                                    noWrap
                                    className={classes.CellWorkRankingBlue}
                                  >
                                    {clientsHandledByCell?.findIndex(
                                      (item) =>
                                        item?.country === selectedCountryValue &&
                                        item?.cell === selectedCellValue,
                                    ) + 1}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Ranking
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={3}>
                                  <Typography variant="h2" noWrap>
                                    {basicDetailsData?.totalActiveClients}
                                  </Typography>
                                </Box>
                                <Box display="flex" mt={1}>
                                  <Typography variant="body2" noWrap>
                                    Clients
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={7}>
                        <Grid container spacing={2} className={classes.CellScrollBox}>
                          {filteredSelectedCountryData?.map((data, index) => (
                            <>
                              <Grid item xs={4}>
                                <Box className={classes.innercontentDefaultcolor} height="100%">
                                  <Box display="flex" flexDirection="column">
                                    <Box display="flex">
                                      <Typography variant="h5" noWrap>
                                        {data?.cell}
                                      </Typography>
                                    </Box>
                                    <Box display="flex">
                                      <Typography variant="h6" noWrap>
                                        {data?.country}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={3}>
                                      <Typography
                                        variant="h2"
                                        noWrap
                                        className={classes.CellWorkRankingBlue}
                                      >
                                        {clientsHandledByCell?.findIndex(
                                          (item) =>
                                            item?.country === data?.country &&
                                            item?.cell === data?.cell,
                                        ) + 1}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={1}>
                                      <Typography variant="body2" noWrap>
                                        Ranking
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={3}>
                                      <Typography variant="h2" noWrap>
                                        {data?.totalActiveClients}
                                      </Typography>
                                    </Box>
                                    <Box display="flex" mt={1}>
                                      <Typography variant="body2" noWrap>
                                        Clients
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                            </>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    );
  };

export default CellWorkLoad;
